import { render, staticRenderFns } from "./InactiveItemDialog.vue?vue&type=template&id=c2e6d9c0&scoped=true"
import script from "./InactiveItemDialog.vue?vue&type=script&lang=js"
export * from "./InactiveItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e6d9c0",
  null
  
)

export default component.exports